import { render, staticRenderFns } from "./RoundName.vue?vue&type=template&id=b4bfd11e&"
import script from "./RoundName.vue?vue&type=script&lang=js&"
export * from "./RoundName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports